import React from 'react';
import { subscribeToNewsletter } from '../../services/parse.js';
import { NotificationManager } from 'react-notifications';

import './NewsletterForm.scss';

export default class NewsletterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        emailAddress: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ emailAddress: event.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();

    subscribeToNewsletter({
      email: this.state.emailAddress,
      listId: parseInt(process.env.REACT_APP_ITERABLE_EMAIL_LISTID),
      source: 'blog'
    }).then((results) => {
      NotificationManager.success('Your email has been added to our mailing list. Thank you!', '', 5000);
      this.setState({ emailAddress: '' });

      window.dataLayer.push({
        'event': 'newsletterSignup',
        'emailAddress' : this.state.emailAddress,
        'userType': 'newsletter',
      });
    }).catch((error) => {
      console.log(error);
      NotificationManager.error('We\'re sorry, something went wrong. Please try again.', '', 50000);
    });
  }

  render() {
    return (
      <form className="email-form" onSubmit={ e => this.handleSubmit(e) }>
        <input type="email" name="MERGE0" id="mk_search" aria-required="true" aria-invalid="false" placeholder="Email address" value={ this.state.emailAddress } onChange={this.handleChange} required />
        <input type="submit" value="Sign up" />
        <input type="hidden" name="MERGE3" value="Other" checked readOnly />
      </form>
    );
  }
}
